import {
    fetchApiHeaders,
    globalURL
} from "../../helpers/constants";
import {
    getIndividualCategories,
    getIndividualColors,
    getIndividualProducts
} from "../../helpers/functions";


export const setFilterValue = (key, value) => dispatch => {
    dispatch({
        type: "SET_FILTER_VALUE",
        payload: {
            key: key,
            value: value
        }
    })
}

export const clearFilter = () => dispatch => {
    dispatch({
        type: "CLEAR_FILTER"
    })
}

export const onChangeFilter = (key, value, filterType) => dispatch => {
    dispatch({
        type: "ON_CHANGE_FILTER",
        payload: {
            key: key,
            value: value,
            filterType
        }
    })
}

export const getProducts = (query) => dispatch => {
    dispatch({
        type: "GET_SHOP_PRODUCTS"
    })

    fetch(globalURL + "/stockCard/getAllProducts", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST
        }
    })
        .then((data) => data.json())
        .then(async (data) => {
            if (data.success) {
                const uniqueCategories = getIndividualCategories(data.data);
                const uniqueColors = getIndividualColors(data.data);
                const uniqueProducts = getIndividualProducts(data.data);

                dispatch({
                    type: "FETCH_SHOP_PRODUCTS",
                    payload: data.data,
                    uniqueCategories: uniqueCategories,
                    uniqueColors: uniqueColors,
                    uniqueProducts: uniqueProducts,
                    query : query
                })
            } else {
                dispatch({
                    type: "ERROR_SHOP_PRODUCTS",
                    payload: data
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "ERROR_SHOP_PRODUCTS",
                payload: error
            });
        })
}

